import type { StateObject } from "../../../redux/types"
import { getCurrentAgenda } from "../../../router/selectors"
import { MainMenuAgendaEnum } from "../../../router/types"
import type {
    HourlyPreparationTime,
    PreparationTimeByItemReport,
    PreparationTimeHourlyReport,
} from "../../../../graphql/types"
import { PreparationTimeByItemRequestData } from "../../../../graphql/types"
import { getFilters, getSelectedLocationIdsFromGlobalFilter, isStateLoading } from "../../../filters/selectors"
import { GLOBAL_FILTER_IDENTIFIER } from "../../../filters/reducer"
import { getReportsStateObject } from "../selectors"
import { pipeline } from "@figurepos/fgr-lib-business-logic/lib/common/functional"
import { isEmpty, map, range } from "ramda"
import { createEmptyHourlyPreparationTime } from "./functions"
import { getMidnightOffset } from "../../settings/selectors"

export const isPreparationTimeReportAgendaOpened = (state: StateObject) =>
    getCurrentAgenda(state) === MainMenuAgendaEnum.PreparationTime

export const getPreparationTimeReportQueryApiParam = (state: StateObject): PreparationTimeByItemRequestData => {
    const globalFilters = getFilters(state, GLOBAL_FILTER_IDENTIFIER)
    const selectedLocationIds = getSelectedLocationIdsFromGlobalFilter(state)
    const locationIds = selectedLocationIds ? selectedLocationIds.join() : null
    const from = globalFilters && globalFilters.date && globalFilters.date.from
    const to = globalFilters && globalFilters.date && globalFilters.date.to

    return {
        from: from,
        to: to,
        locationIds: locationIds,
    } as PreparationTimeByItemRequestData
}

export const isPreparationTimeByItemReportLoading = (state: StateObject): boolean =>
    isStateLoading(state, "preparation-time-by-item-report")

export const isPreparationTimeHourlyReportLoading = (state: StateObject): boolean =>
    isStateLoading(state, "preparation-time-hourly-report")

export const getPreparationTimeByItemReportData = (state: StateObject): PreparationTimeByItemReport =>
    getReportsStateObject(state).preparationTime.byItem

export const getPreparationTimeHourlyReportData = (state: StateObject): PreparationTimeHourlyReport => {
    const midnightOffset = getMidnightOffset(state) / 60
    const data = getReportsStateObject(state).preparationTime.hourly

    if (!data || isEmpty(data.hours)) {
        return {
            hours: pipeline(
                range(0, 25),
                map(
                    (index: number): HourlyPreparationTime =>
                        createEmptyHourlyPreparationTime(index + midnightOffset, index)
                )
            ),
        }
    }

    return getReportsStateObject(state).preparationTime.hourly
}
